module.exports = __webpack_public_path__ + "static/media/survey.da5347fa.svg";